// @ts-nocheck
import React, { useState, useEffect } from 'react';
import euforms from "../../images/euforms.png";
import { URL } from '../../service/Service';
import {
    CheckCircleIcon,
    ExclamationCircleIcon
} from '@heroicons/react/24/outline';

const MBWay = ({ paymentinfo }) => {

    const [timeLeft, setTimeLeft] = useState(240);
    const [paymentStatus, setPaymentStatus] = useState('UNPAID');
    const [statusError, setStatusError] = useState(false);

    const isPaid = paymentStatus === 'PAID';


    useEffect(() => {

        if (timeLeft === 0 || isPaid) {
            return;
        }

        const intervalId = setInterval(() => {
            setTimeLeft(
                current => Math.max(0, current - 1)
            );
        }, 1000);

        return () => clearInterval(intervalId);

    }, [timeLeft, isPaid]);


    useEffect(() => {

        if (!paymentinfo?.replyID || isPaid) {
            return;
        }

        let active = true;


        const checkPaymentStatus = async () => {

            try {

                const response = await fetch(
                    `${URL}/api/payment/status/${encodeURIComponent(paymentinfo.replyID)}`,
                    {
                        headers: {
                            accept: 'application/json'
                        }
                    }
                );


                if (!response.ok) {
                    throw new Error(
                        `HTTP ${response.status}`
                    );
                }


                const data = await response.json();


                if (active) {

                    setPaymentStatus(
                        data.status
                    );

                    setStatusError(false);
                }

            } catch (_error) {

                if (active) {
                    setStatusError(true);
                }
            }
        };


        checkPaymentStatus();


        const intervalId = setInterval(
            checkPaymentStatus,
            2500
        );


        return () => {

            active = false;

            clearInterval(
                intervalId
            );
        };

    }, [paymentinfo?.replyID, isPaid]);


    const formatTime = (seconds) => {

        const minutes =
            Math.floor(seconds / 60);

        const remainingSeconds =
            seconds % 60;

        return `${minutes}:${
            remainingSeconds < 10
                ? '0'
                : ''
        }${remainingSeconds}`;
    };


    return (

        <div className="overflow-x-hidden">

            <nav className="flex items-center justify-between flex-wrap bg-green-cl p-6">

                <div className="flex items-center flex-shrink-0 text-white mr-6">

                    <img
                        className="h-8"
                        src={euforms}
                        alt="Logo"
                    />

                </div>

            </nav>


            <div className="mt-20 flex flex-col items-center justify-center bg-gray-100">

                <div className="bg-white shadow-md rounded-lg p-12 w-full max-w-4xl">

                    <h1 className="text-4xl font-bold text-green-600 text-center mb-10">

                        {
                            isPaid
                                ? 'Pagamento confirmado!'
                                : 'O seu formulário foi preenchido com sucesso!'
                        }

                    </h1>


                    <p className="text-gray-600 text-center mb-5 text-lg">

                        {
                            isPaid
                                ? 'Recebemos o pagamento MB WAY'
                                : 'Aguardando aceitação do pagamento MB WAY'
                        }

                        {' '}no valor de{' '}

                        <b>
                            {parseFloat(paymentinfo.value)
                                .toFixed(2)
                                .replace('.', ',')} €
                        </b>

                    </p>


                    <div className="flex justify-center mb-10">

                        <div className="payment-logo-surface inline-flex items-center justify-center rounded-xl px-4 py-3 shadow-sm">

                            <img
                                className="w-24 sm:w-32 object-contain"
                                src="/payment-icons/mbway.webp"
                                alt="MB WAY"
                            />

                        </div>

                    </div>


                    {
                        isPaid ? (

                            <div
                                className="flex flex-col items-center gap-3 mt-4 sm:mt-8 text-green-700"
                                role="status"
                            >

                                <CheckCircleIcon
                                    className="h-16 w-16"
                                    aria-hidden="true"
                                />

                                <p className="text-xl font-semibold">
                                    O pagamento foi concluído com sucesso.
                                </p>

                            </div>

                        ) : timeLeft > 0 ? (

                            <div
                                className="flex justify-center mt-4 sm:mt-8"
                                aria-live="polite"
                            >

                                <div className="text-4xl sm:text-6xl font-bold text-green-600">

                                    {formatTime(timeLeft)}

                                </div>

                            </div>

                        ) : (

                            <div
                                className="flex flex-col items-center gap-3 mt-4 sm:mt-8 text-amber-700"
                                role="status"
                            >

                                <ExclamationCircleIcon
                                    className="h-14 w-14"
                                    aria-hidden="true"
                                />

                                <p className="text-center text-lg font-semibold">

                                    O pagamento ainda não foi confirmado.
                                    Verifique o pedido na aplicação MB WAY.

                                </p>

                            </div>
                        )
                    }


                    {
                        statusError && !isPaid && (

                            <p className="mt-5 text-center text-sm text-gray-500">

                                Não foi possível atualizar o estado neste momento.
                                Vamos tentar novamente automaticamente.

                            </p>
                        )
                    }


                    {/* Donativos */}
                    {
                        paymentinfo.donations &&
                        Object.keys(paymentinfo.donations).length > 0 && (

                            <div className="mt-10">

                                <h2 className="text-2xl font-semibold text-center text-green-600 mb-4">
                                    Donativos
                                </h2>


                                <table className="w-full border-collapse">

                                    <thead className="bg-gray-100">

                                    <tr>

                                        <th className="py-3 px-4 border text-left">
                                            Elemento
                                        </th>

                                        <th className="py-3 px-4 border text-left">
                                            Valor doado
                                        </th>

                                    </tr>

                                    </thead>


                                    <tbody className="divide-y">

                                    {
                                        Object.entries(
                                            paymentinfo.donations
                                        ).map(
                                            ([elementId, amount]) => (

                                                <tr key={elementId}>

                                                    <td className="py-3 px-4 border">
                                                        {elementId}
                                                    </td>

                                                    <td className="py-3 px-4 border">

                                                        {parseFloat(amount)
                                                            .toFixed(2)
                                                            .replace('.', ',')} €

                                                    </td>

                                                </tr>
                                            )
                                        )
                                    }

                                    </tbody>

                                </table>

                            </div>
                        )
                    }

                </div>

            </div>

        </div>
    );
};


export default MBWay;